<template>
  <div class="pa-6">
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Hồ sơ Khối 6 đăng ký lớp HDPPLB</div>
      <DocumentExcelExport />
    </div>
    <v-card class="pa-6 elevation-1 mb-6">
      <DocumentFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card class="elevation-1">
      <DocumentTable ref="documentTable" @onDocumentDetail="onDocumentDetail" />
    </v-card>
    <DocumentDetailDialog :state="dialog" :documentId="selectedDocumentId" @closeDialog="dialog = !dialog" />
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import DocumentFilter from './ListFilter.vue'
import DocumentTable from './ListTable.vue'
import DocumentDetailDialog from '../DocumentDetailDialog.vue'
import DocumentExcelExport from './ExcelExport.vue'
export default {
  components: {DocumentFilter, DocumentTable, DocumentDetailDialog, DocumentExcelExport},
  computed: {
    ...mapGetters('auth', ['user', 'role']),
  },
  async mounted() {
    const query = {adminQueryType: 'g6ExamPrep', fromAdmin: true, nth: 2}
    if (this.user.department === 'both') query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
    else query.department_in = [this.user.department, 'unset']
    if (!this.user.department || this.user.department !== 'both') query.status_ne = 'disabled'
    await this.countCVs(query)
  },
  data: () => ({dialog: false, selectedDocumentId: ''}),
  methods: {
    ...mapActions({fetchCVs: 'cv/fetchCVs', countCVs: 'cv/countCVs', resetState: 'cv/reset'}),
    async onFilterChanged(data) {
      this.$loading.active = true
      const params = {
        ...data,
        adminQueryType: 'g6ExamPrep',
        fromAdmin: true,
      }
      await this.fetchCVs({...params, _start: 0, _limit: 10})
      await this.countCVs(params)
      this.$loading.active = false
    },
    onDocumentDetail(data) {
      this.dialog = true
      this.selectedDocumentId = data
    },
  },
  async beforeDestroy() {
    await this.resetState()
  },
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
